<template>
  <div id="success">
    <div class="success"></div>
    <h5>提交成功，等待线下汇款确认</h5>
    <span>
      您在本协会申请的
      <apply-name/>,
      <br>
      <br>已提交汇款资料信息，
      <br>
      <br>请等待工作人员确认
    </span>

    <div class="btn-group">
      <div class="btn-main btn-home">
        <router-link :to="{path:'/member/pay/offline'}">资料错误？重新提交</router-link>
      </div>
      <div class="btn-main btn-home">
        <router-link :to="{path:'/'}">返回首页</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ApplyName from '@/components/member/ApplyName.vue'
export default {
  components: {
    ApplyName
  },
  data() {
    return {
      rejectReason: ''
    }
  },
  created() {
    this.getRejectReason()
  },
  methods: {
    getRejectReason() {
      this.$fetch('/api/OrganizationEnterprise/GetOrganizationRejectReason').then(result => {
        this.rejectReason = result
      })
    }
  }
}
</script>

<style lang="less" scoped>
#success {
  height: 100%;
  background: #fff;
}

.success {
  width: 100%;
  height: 437 / @rem-size;
  background: url('../../assets/images/success.png');
  background-size: 100% 100%;
}

h5 {
  font-size: 36 / @rem-size;
  color: #333;
  margin-top: 24 / @rem-size;
  font-weight: normal;
  text-align: center;
}

span {
  display: block;
  font-size: 28 / @rem-size;
  text-align: center;
  margin-top: 24 / @rem-size;
  color: #999;

  em {
    color: #333;
    font-style: normal;
  }
}
.btn-group {
  margin-top: 120 / @rem-size;
  text-align: center;
  .btn-home {
    display: inline-block;
    &:last-child {
      margin-left: 20 / @rem-size;
    }
  }
}
.btn-home {
  width: 320 / @rem-size;
  height: 80 / @rem-size;
  text-align: center;
  line-height: 80 / @rem-size;
  font-size: 30 / @rem-size;
  margin: 0 auto;

  border-radius: 8 / @rem-size;

  a {
    color: #fff;
  }
}
</style>
